module.exports = __webpack_public_path__ + "img/main-bg.c5e88fec.png";